import { createTheme } from "@material-ui/core";

const CITheme = createTheme({
    palette: {
        primary: {
            BG: "#207067",
            main: "#7C382D",
            light: "#CEB891",
            tooltip: "#EDDBAD",
            contrast: "#FBF6D8",
            text: "#7C382D99"
        }
    }
});

export default CITheme;